import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import PasswordResetWeb from './web';
import PasswordResetMob from './mob';

type Props = {
  token: string;
};

const PasswordReset = ({ token }: Props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <PasswordResetMob token={token} /> : <PasswordResetWeb token={token} />;
};

export default PasswordReset;
